import z from "zod/v4";

import { ActionTypeSchema } from "../../../schemas/ai/enums";
import { SessionStatusSchema } from "../../../schemas/ai/session";

export const WorkflowResponseBodyDtoSchema = z.object({
  sessionId: z.uuid(),
  executionId: z.uuid(),
  status: SessionStatusSchema,
  nextAction: ActionTypeSchema,
});

export type WorkflowResponseBodyDto = z.infer<
  typeof WorkflowResponseBodyDtoSchema
>;
